import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const RISK_FILES_ENDPOINTS = {
  list: `${BASE_URL}api/risk_files/`,
  download: `${BASE_URL}api/risk_files/download/`,
  download_all: `${BASE_URL}api/risk_files/download/all`,
  get_category_mapping: (id_campaign, id_member) => `${BASE_URL}api/risk_files/category_mapping/${id_campaign}/${id_member}`,
  download_riskfile: (id_campaign, id_member) => `${BASE_URL}api/risk_files/${id_campaign}/${id_member}/riskfile/download`
};

class Risk_files {
  async editRiskFiles(clients, query={}) {
    return await request({
      url: RISK_FILES_ENDPOINTS.list,
      method: "PUT",
      body: clients,
      query
    });
  }

  async getCategoryMapping(id_campaign, id_member) {
    return await request({
      url: RISK_FILES_ENDPOINTS.get_category_mapping(id_campaign, id_member),
    });
  }
}

export const RiskFilesServices = new Risk_files();
